<template>
  <el-dialog
    title="选择移动到"
    :visible.sync="groupInfo.show"
    v-if="groupInfo.show"
    width="450px"
  >
    <el-table
      :data="groupNameList.slice(1)"
      highlight-current-row
      headerRowClassName="RCTableHeader"
      cellClassName="RCTableCell"
    >
      <el-table-column label="" width="50">
        <template slot-scope="scope">
          <el-radio
            :label="scope.$index"
            v-model="radio"
            @change.native="getCurrentRow(scope.$index, scope.row)"
          >
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column property="paramValue" label="班组名称">
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureMove" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { moveGroup } from "@/api/groupManage";

export default {
  components: { butn },
  props: {
    groupInfo: {
      type: Object,
      default: () => {},
    },
    groupNameList: {
      type: Array,
      default: () => [],
    },
    classId: {
      type: String,
      default: "",
    },
  },
  watch: {
    "groupInfo.oldIndex": {
      handler(newVal) {
        this.radio = newVal;
      },
      immediate: true,
    },
  },
  data() {
    return {
      newGroupId: "",
      radio: 0,
    };
  },
  methods: {
    closeDia() {
      this.$emit("closeDia");
    },
    getCurrentRow(index, row) {
      this.radio = index;
      this.newGroupId = row.paramKey;
    },
    sureMove() {
      moveGroup({
        enrollIds: this.groupInfo.enrollId,
        newGroupId: this.newGroupId || this.groupInfo.oldGroupId,
        classId: this.classId,
      }).then(({ code, msg }) => {
        if (code !== 0) return;
        this.$message.success(msg);
        this.$emit("refreshNowPage");
        this.$emit("closeDia");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-radio__label {
  display: none;
}
</style>
